export var ELoadingSize;
(function (ELoadingSize) {
    ELoadingSize[ELoadingSize["Small"] = 12] = "Small";
    ELoadingSize[ELoadingSize["Medium"] = 24] = "Medium";
    ELoadingSize[ELoadingSize["Large"] = 40] = "Large";
})(ELoadingSize || (ELoadingSize = {}));
